exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._19uxs{background:#fff;padding-top:20px;-webkit-box-shadow:inset 0 2px 4px 0 rgba(0,0,0,.05);box-shadow:inset 0 2px 4px 0 rgba(0,0,0,.05)}._2Ug1D{width:1180px;margin:0 auto;position:relative;padding-bottom:45px}._3Y8-w{margin-top:20px}._2_ZK9,._34yRr{font-size:26px;color:#31404c;margin:30px 0 20px}._34yRr{margin-top:16px}", ""]);

// exports
exports.locals = {
	"root": "_19uxs",
	"inner": "_2Ug1D",
	"courses": "_3Y8-w",
	"title": "_2_ZK9",
	"title2": "_34yRr"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/components/p_home/SlideArea/index.css
// module id = 1218
// module chunks = 1